import { CircularProgressCircle } from 'components/CircularProgressCircle';
import { CircularProgressText } from 'components/CircularProgressText';

type CircularProgressProps = { text: boolean } & (
  | {
      percentage: number;
      value?: never;
      maxValue?: never;
      className?: string;
    }
  | {
      percentage?: never;
      value: number;
      maxValue: number;
      className?: string;
    }
);

const CircularProgress = (props: CircularProgressProps) => {
  const { text, percentage, value, maxValue } = props;
  const circProgressSize: number = 40;
  const viewBox: string = `0 0 ${circProgressSize} ${circProgressSize}`;

  return (
    <svg
      data-testid="circularProgress"
      width={circProgressSize}
      height={circProgressSize}
      viewBox={viewBox}
    >
      <CircularProgressCircle
        circProgressSize={circProgressSize}
        progressPercentage={
          percentage !== undefined ? percentage : (value / maxValue) * 100
        }
      />
      {text && (
        <CircularProgressText
          progressText={
            percentage !== undefined ? `${percentage}%` : `${value}/${maxValue}`
          }
        />
      )}
    </svg>
  );
};

CircularProgress.displayName = 'CircularProgress';

export { CircularProgress, type CircularProgressProps };
